import React, { Fragment } from "react";
import PropTypes from "prop-types";

const fabric = window.fabric;

class DesignCanvas extends React.Component {
  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    downloadFile: PropTypes.any,
    rotateCanvas: PropTypes.bool || false,
  };

  static defaultProps = {
    width: 1000,
    height: 550,
  };

  state = {
    canvas: null,
  };

  componentDidMount() {
    const canvas = new fabric.Canvas(this.c);
    this.setState({ canvas });
  }

  render() {
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        canvas: this.state.canvas,
      });
    });

    const { width, height } = this.props;
    const isInApp = typeof window.ReactNativeWebView !== "undefined";
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isMobileOrApp = isInApp || isMobile;

    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <canvas
            id="certificate"
            ref={(c) => (this.c = c)}
            width={width}
            height={height}
            style={{
              position: "absolute",
              top: this.props.rotateCanvas ? "90px" : "0px",
              // marginTop: this.props.rotateCanvas ? "90px" : "0px",
              transform: this.props.rotateCanvas ? "rotate(90deg)" : "none",
              transformOrigin: "center center",
            }}
          />

          {this.state.canvas && children}
        </div>
      </Fragment>
    );
  }
}

export default DesignCanvas;
